import React from 'react';
import './index.scss';

const Progress = (props) => {
    let color;
    if (props.Score <= 12) {
        color = "#fca579";
    } else if (props.Score > 12 && props.Score < 20) {
        color = "#ffd58c";
    } else if (props.Score >= 20) {
        color = "#19b0a9";
    } else {
        color = "#F26B21";
    }
    let offset = 5;

    let total = 25;

    let label = 15;
    let twelve = "50%";
    let twenty = "75.5%";


    if (props.role === "child") {
        label = 12;
        offset = 0;
        total = 27;
        twelve = "44.44444444444444%";
        twenty = "74.07407407407408%";
    }

    const weightedScore = props.Score > offset ? ((props.Score - offset) / (total - offset) * 100) : 0;
    console.log(weightedScore);
    let dotCss = { left: `${weightedScore}%`, backgroundColor: color };
    let markerCss = { left: `${weightedScore}%`, fill: color };
    return (
        <div className="progress">
            <div className="progressContainer">
                <svg className="marker" width="11" height="15" viewBox="0 0 9.86 14" style={markerCss}>
                    <path d="M474.36,474.5c0,3-4.93,8.5-4.93,8.5s-4.93-5.46-4.93-8.5a5,5,0,1,1,9.86,0Z" transform="translate(-464.5 -469)" />
                    <ellipse cx="4.93" cy="5.29" rx="2.5" ry="2.69" />
                </svg>
                <div className="pos" style={dotCss}></div>
                <svg width="100%" height="40" viewBox="0 0 100% 40">
                    <line x1="0" y1="15" x2={twelve} y2="15" stroke="#fca579" />
                    <line x1={twelve} y1="15" x2={twenty} y2="15" stroke="#ffd58c" />
                    <line x1={twenty} y1="15" x2="100%" y2="15" stroke="#19B0A9" />
                    <text className="legal number" x="0" y="0" alignmentBaseline="hanging" textAnchor="start">{offset}</text>
                    <text className="legal number" x={twelve} y="0" alignmentBaseline="hanging" textAnchor="middle">{label}</text>
                    <text className="legal number" x={twenty} y="0" alignmentBaseline="hanging" textAnchor="middle">20</text>
                    <text className="legal number" x="100%" y="0" alignmentBaseline="hanging" textAnchor="end">{total}</text>
                    <text className="legal alpha" x="0" y="30" alignmentBaseline="hanging" textAnchor="start">Very Poorly Controlled</text>
                    <text className="legal alpha notWell" x="55%" y="30" alignmentBaseline="hanging" textAnchor="middle">Not Well Controlled</text>
                    <text className="legal alpha" x="100%" y="30" alignmentBaseline="hanging" textAnchor="end">Well Controlled</text>
                </svg>
            </div>
        </div>
    );
}

export default Progress;
